import React, { useState } from "react";
import { connect } from "react-redux";
import { FiEye, FiEyeOff } from "react-icons/fi";
import "./style.css";
import ClipLoader from "react-spinners/ClipLoader";
import baseUrlNew from "../BaseUrl/index";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getcardetaol_ } from "../Redux/reduxflow/action";
import InspectionShell from "../components/InspectionShell";
import {
  INSPECTION_BASE_PATH,
  setInspectionUserId,
} from "../utils/authStorage";

function apiHost() {
  const raw = baseUrlNew?.baseUrl || baseUrlNew?.baseUrl || "";
  return String(raw).replace(/\/?$/, "/");
}

function readUserId(payload) {
  const data = payload?.data;
  return (
    data?.user_id ||
    data?.id ||
    data?.pk ||
    data?.user?.id ||
    payload?.user_id ||
    payload?.id ||
    null
  );
}

function readError(payload, fallback) {
  return (
    payload?.message?.description ||
    payload?.message?.detail ||
    (typeof payload?.message === "string" ? payload.message : "") ||
    payload?.detail ||
    payload?.error ||
    fallback
  );
}

export const Login = () => {
  const [login_loading, setlogin_loading] = useState(false);
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [formError, setFormError] = useState("");

  const loginUrl = `${apiHost()}api/v1/inspection_login/`;

  const showError = (text) => {
    const message = text || "Could not sign in. Please try again.";
    setFormError(message);
    toast.error(message);
  };

  const Log_In_User = async (emailVal, passwordVal) => {
    setFormError("");
    try {
      const response = await axios.post(loginUrl, {
        email: emailVal,
        password: passwordVal,
      });
      const payload = response?.data || {};
      const failed =
        payload?.message?.type === "error" ||
        /incorrect|invalid|failed/i.test(
          String(payload?.message?.description || "")
        );
      const userId = readUserId(payload);

      if (failed || !userId) {
        showError(
          readError(payload, "Email or password is incorrect.")
        );
        return;
      }

      setInspectionUserId(userId);
      window.location.assign(INSPECTION_BASE_PATH);
    } catch (err) {
      const payload = err?.response?.data;
      showError(
        readError(
          payload,
          err?.message?.includes("Network")
            ? "Could not reach the server. Check the API and try again."
            : "Could not sign in. Please try again."
        )
      );
    } finally {
      setlogin_loading(false);
    }
  };

  const loginhandeler = (event) => {
    event.preventDefault();
    setlogin_loading(true);
    Log_In_User(email, password);
  };

  return (
    <InspectionShell badge="Inspection" mainClassName="pi-inspection-main--center">
      <div className="pi-inspection-status-card">
        <p className="pi-inspection-label">Staff access</p>
        <h1>Sign in</h1>
        <p>Use the inspection user email and password created by the dealer.</p>
        <form className="pi-inspection-login-form" onSubmit={loginhandeler}>
          <label className="sr-only" htmlFor="inputEmail">
            Email address
          </label>
          <input
            onChange={(e) => setemail(e.target.value)}
            value={email}
            type="email"
            id="inputEmail"
            className="pi-inspection-field"
            placeholder="Email address"
            required
            autoFocus
            autoComplete="username"
          />
          <label className="sr-only" htmlFor="inputPassword">
            Password
          </label>
          <div className="pi-inspection-password">
            <input
              onChange={(e) => setpassword(e.target.value)}
              value={password}
              type={showPassword ? "text" : "password"}
              id="inputPassword"
              className="pi-inspection-field pi-inspection-field--password"
              placeholder="Password"
              required
              autoComplete="current-password"
            />
            <label
              className="pi-inspection-password__toggle"
              htmlFor="inspection-show-password"
            >
              <input
                id="inspection-show-password"
                type="checkbox"
                className="sr-only"
                checked={showPassword}
                onChange={(e) => setShowPassword(e.target.checked)}
              />
              <span className="sr-only">
                {showPassword ? "Hide password" : "Show password"}
              </span>
              {showPassword ? <FiEyeOff size={18} aria-hidden /> : <FiEye size={18} aria-hidden />}
            </label>
          </div>
          {formError ? (
            <p className="pi-inspection-login-error" role="alert">
              {formError}
            </p>
          ) : null}
          {login_loading ? (
            <div className="pi-inspection-login-loader">
              <ClipLoader size={36} color="#2563eb" />
            </div>
          ) : (
            <button className="pi-inspection-continue-btn" type="submit">
              Sign in
            </button>
          )}
        </form>
      </div>
      <ToastContainer position="top-center" autoClose={4000} />
    </InspectionShell>
  );
};

const mapStateToProps = (state) => ({
  car_detail_data: state.cardata.car_detail_data,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getcardetaol_: (response) => dispatch(getcardetaol_(response)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
